export const FETCH_PROVIDER_AVAILABILITY_START =
  'FETCH_PROVIDER_AVAILABILITY_START';
export const FETCH_PROVIDER_AVAILABILITY_FAILURE =
  'FETCH_PROVIDER_AVAILABILITY_FAILURE';
export const FETCH_PROVIDER_AVAILABILITY_SUCCESS =
  'FETCH_PROVIDER_AVAILABILITY_SUCCESS';

export const SET_PROVIDER_DETAILS = 'SET_PROVIDER_DETAILS';
export const UPDATE_FETCHED_PROVIDERS = 'UPDATE_FETCHED_PROVIDERS';
export const RESET_PROVIDER_AVAILABILITY = 'RESET_PROVIDER_AVAILABILITY';
export const RESET_CLIENTS_AVAILABILITY = 'RESET_CLIENTS_AVAILABILITY';

export const FETCH_PAGINATED_PROVIDERS_START =
  'FETCH_PAGINATED_PROVIDERS_START';
export const FETCH_PAGINATED_PROVIDERS_FAILURE =
  'FETCH_PAGINATED_PROVIDERS_FAILURE';
export const FETCH_PAGINATED_PROVIDERS_SUCCESS =
  'FETCH_PAGINATED_PROVIDERS_SUCCESS';

export const RESET_FILTERS = 'RESET_FILTERS';

export const FETCH_PAGINATED_CLIENTS_START = 'FETCH_PAGINATED_CLIENTS_START';
export const FETCH_PAGINATED_CLIENTS_FAILURE =
  'FETCH_PAGINATED_CLIENTS_FAILURE';
export const FETCH_PAGINATED_CLIENTS_SUCCESS =
  'FETCH_PAGINATED_CLIENTS_SUCCESS';

export const FETCH_ALL_APPOINTMENTS_START = 'FETCH_ALL_APPOINTMENTS_START';
export const FETCH_ALL_APPOINTMENTS_FAILURE = 'FETCH_ALL_APPOINTMENTS_FAILURE';
export const FETCH_ALL_APPOINTMENTS_SUCCESS = 'FETCH_ALL_APPOINTMENTS_SUCCESS';

export const SCHEDULE_APPOINTMENT_START = 'SCHEDULE_APPOINTMENT_START';
export const SCHEDULE_APPOINTMENT_FAILURE = 'SCHEDULE_APPOINTMENT_FAILURE';
export const SCHEDULE_APPOINTMENT_SUCCESS = 'SCHEDULE_APPOINTMENT_SUCCESS';

export const CANCEL_APPOINTMENT_START = 'CANCEL_APPOINTMENT_START';
export const CANCEL_APPOINTMENT_FAILURE = 'CANCEL_APPOINTMENT_FAILURE';
export const CANCEL_APPOINTMENT_SUCCESS = 'CANCEL_APPOINTMENT_SUCCESS';

export const UPDATE_APPOINTMENT_START = 'UPDATE_APPOINTMENT_START';
export const UPDATE_APPOINTMENT_FAILURE = 'UPDATE_APPOINTMENT_FAILURE';
export const UPDATE_APPOINTMENT_SUCCESS = 'UPDATE_APPOINTMENT_SUCCESS';

export const SET_SELECTED_APPOINTMENT_ID = 'SET_SELECTED_APPOINTMENT_ID';
export const RESET_SELECTED_APPOINTMENT_ID = 'RESET_SELECTED_APPOINTMENT_ID';
export const RESET_APPOINTMENTS_STATE = 'RESET_APPOINTMENTS_STATE';
export const RESET_SPECIFIC_DAYS_APPOINTMENTS_STATE =
  'RESET_SPECIFIC_DAYS_APPOINTMENTS_STATE';

export const EXPORT_APPOINTMENTS_CSV_START = 'EXPORT_APPOINTMENTS_CSV_START';
export const EXPORT_APPOINTMENTS_CSV_SUCCESS =
  'EXPORT_APPOINTMENTS_CSV_SUCCESS';
export const EXPORT_APPOINTMENTS_CSV_FAILURE =
  'EXPORT_APPOINTMENTS_CSV_FAILURE';

export const EXPORT_APPOINTMENTS_ASYNC_START =
  'EXPORT_APPOINTMENTS_ASYNC_START';
export const EXPORT_APPOINTMENTS_ASYNC_SUCCESS =
  'EXPORT_APPOINTMENTS_ASYNC_SUCCESS';
export const EXPORT_APPOINTMENTS_ASYNC_FAILURE =
  'EXPORT_APPOINTMENTS_ASYNC_FAILURE';
export const EXPORT_APPOINTMENTS_PROGRESS_UPDATE =
  'EXPORT_APPOINTMENTS_PROGRESS_UPDATE';
export const EXPORT_APPOINTMENTS_POLLING_COMPLETE =
  'EXPORT_APPOINTMENTS_POLLING_COMPLETE';
export const RESET_EXPORT_STATE = 'RESET_EXPORT_STATE';

export const FETCH_APPOINTMENT_ACTIVITY_LOGS_START =
  'FETCH_APPOINTMENT_ACTIVITY_LOGS_START';
export const FETCH_APPOINTMENT_ACTIVITY_LOGS_SUCCESS =
  'FETCH_APPOINTMENT_ACTIVITY_LOGS_SUCCESS';
export const FETCH_APPOINTMENT_ACTIVITY_LOGS_FAILURE =
  'FETCH_APPOINTMENT_ACTIVITY_LOGS_FAILURE';
export const RESET_APPOINTMENT_ACTIVITY_LOGS =
  'RESET_APPOINTMENT_ACTIVITY_LOGS';
